import React from 'react';
import './App.css';
import Pages from "./components/pages"

const App = () => {
  return (
    <div className="App">
        <Pages/>
    </div>
  );
}

export default App;
